module.exports = __webpack_public_path__ + "img/pop_shouxin_king.200f3c13.png";